import { EDIT_MODE } from '../../../../constant/Safety/Common/mode';
import updateButtonDisabled from '../../../Common/Controller/Handler/updateButtonDisabled';
import convertDataFormat from '../../Common/Handler/convertDataFormat';
import deleteProperty from '../../Common/Handler/deleteProperty';
import separateFileTableData from '../../Common/Handler/separateFileTableData';
import uploadMultipleFile from '../../Common/Handler/uploadMultipleFile';

const saveAccident = ({
  seq,
  handleSubmit,
  modalType,
  postAccidentMutator,
  patchAccidentMutator,
  nameObject,
  saveButtonRef,
}) => {
  handleSubmit(async submitData => {
    if (saveButtonRef)
      updateButtonDisabled({ ref: saveButtonRef, disabled: true });
    const formatData = convertDataFormat({
      inputData: submitData,
      date: ['accident_date', 'claim_date', 'paid_date'],
      number: ['balance_due', 'paid_amt', 'amount_to_pay'],
    });

    /** Add Type */
    formatData.type = nameObject[formatData?.name];

    /** Set Doc Data */
    const separatedData = separateFileTableData({ inputData: formatData });

    /** Remove unnecessary data */
    const sanitizedData = deleteProperty({ inputData: separatedData });

    /** Mutate */
    if (modalType === EDIT_MODE?.edit) {
      // Upload -> Patch
      const manipulatedData = await uploadMultipleFile({
        inputData: sanitizedData,
        uploadPath: `safety/accident/${seq}`,
      });
      patchAccidentMutator({
        seq,
        patchData: manipulatedData,
        buttonRef: saveButtonRef,
      });
    }
    if (modalType === EDIT_MODE?.add) {
      // Post -> Upload -> Patch
      // Delete file-related data temporarily
      const document = sanitizedData?.doc;
      delete sanitizedData?.doc;

      // 1. Post
      postAccidentMutator(
        { postData: sanitizedData, buttonRef: saveButtonRef },
        {
          onSuccess: async responseData => {
            const createdSeq = responseData?.data?.seq;

            // 2. Upload
            const manipulatedData = await uploadMultipleFile({
              inputData: {
                ...sanitizedData,
                doc: document,
              },
              uploadPath: `safety/accident/${createdSeq}`,
            });

            // 3. Patch
            patchAccidentMutator({
              seq: createdSeq,
              patchData: manipulatedData,
              buttonRef: saveButtonRef,
            });
          },
        },
      );
    }
  })();
};

export default saveAccident;
